import { FormControl, FormLabel, Select, Step, Stepper } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import type { Currency } from '@weft/types';
import { CURRENCIES } from '@weft/types';
import { values } from '@weft/utils';
import React from 'react';
import { VyStepLabel } from '../../../../../components/new-design/data-display/VyStepLabel';
import { OldVySwitch } from '../../../../../components/new-design/inputs/OldVySwitch';
import { useCreateInvoiceContext } from '../../create-invoice-page-contexts/create-invoice-context/create-invoice-context';
import { INVOICE_CREATION_STEPS } from '../../create-invoice-page-contexts/create-invoice-context/create-invoice-context-types/invoice-creation-step';

type CreateInvoiceStepperProps = {
  currency: Currency;
};

export const CreateInvoiceStepper: React.FC<CreateInvoiceStepperProps> = ({ currency }) => {
  const { invoiceCreationStepper: { currentStep, goToStep }, planPreview: { open, hide, show } } = useCreateInvoiceContext();

  const handlePlanPreviewSwitch = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    checked ? show() : hide();
  };

  return (
    <div className="flex justify-between border-b border-b-[#DCE8EF] bg-white px-6 py-4">
      <FormControl
        disabled
        className="flex flex-row items-center gap-x-2"
      >
        <FormLabel
          className="text-xs font-medium"
          htmlFor="currency-select"
        >
          Currency
        </FormLabel>

        <Select
          id="currency-select"
          value={currency}
          variant='outlined'
          size="small"
          className="w-[100px]"
        >
          {
            values(CURRENCIES).map((currentCurrency) => (
              <MenuItem
                key={currentCurrency}
                value={currentCurrency}
              >
                {currentCurrency}
              </MenuItem>
            ))
          }
        </Select>
      </FormControl>

      <Stepper activeStep={currentStep}>
        <Step
          className="hover:cursor-pointer"
          onClick={() => goToStep(INVOICE_CREATION_STEPS.settings)}
        >
          <VyStepLabel>
            Invoice details
          </VyStepLabel>
        </Step>

        <Step>
          <VyStepLabel>Pricing options</VyStepLabel>
        </Step>
      </Stepper>

      <FormControl
        className="flex flex-row items-center gap-x-2"
      >
        <FormLabel
          className="text-[#111B1E] text-xs font-normal"
          htmlFor="plan-preview-switch"
        >
          Invoice Preview
        </FormLabel>
        <OldVySwitch
          id="plan-preview-switch"
          checked={open}
          onChange={handlePlanPreviewSwitch}
        />
      </FormControl>
    </div>
  );
};